//
// Generated class TransferNoteLine
//

/// <reference path="TransferNoteLine_ManagedObject.ts" />

class TransferNoteLine extends TransferNoteLine_ManagedObject
{

}
